import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'simplePagination';
import 'slick';
import { bookingFormCommon } from "../c005-bookingform-common";
import * as numeral from 'numeral';

export class enrichCatelogue {
	private catelogueForm: any = $('.member-enrich-newcatalogue');
	private bookingformcommon = new bookingFormCommon();
	private initialBal: any;
	private voucherList: any;
	private vouchLimit: any;
	private vouchCategry: any;
	private voucherRedemList: any;
	private incrementDisplayValue: any = 1;
	private countryList: any;
	private bannerList: any;
	private mhCountry: any;
	private banId: any;
	private slideIndex: any = 1;
	loadCountryBanrData(): void {
		let _self = this;
		let getDataListUrl: string = '';
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('mhCountry')) {
			if (_self.mhCountry == "CFFECO") {
				_self.mhCountry = "MALAYSIA";
			} else {
				_self.mhCountry = urlParams.get('mhCountry');
			}
		} else {
			_self.mhCountry = "MALAYSIA";
		}
		if (urlParams.get('id')) {
			_self.banId = urlParams.get('id');
			if(_self.banId){
				$(".backbutton").removeClass("hide");
			} else {
				$(".backbutton").addClass("hide");
			}
		}
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			getDataListUrl = '/dummy-data/enrich-catelogue.json';
		}
		else {
			getDataListUrl = '/bin/services/new/getCountryBanerList?mhCountry=' + _self.mhCountry + '&banId=' + _self.banId;
		}
		$.get(getDataListUrl)
			.done((data: any) => {
				if (typeof data === 'string') {
					data = JSON.parse(data);
				}
				_self.countryList = data.countriesList;
				_self.bannerList = data.bannerList;
				let dynamicListHtml = `<select class="country-dropdown" id="mh-country-dropdown">`;
				let dynamicImgHtml = '';
				for (let i = 0; i < _self.countryList.length; i++) {
					//alert("country.."+_self.country);
					if ((_self.mhCountry).toLowerCase() == (data.countriesList[i].countryCode).toLowerCase()) {
						dynamicListHtml += `<option value="${data.countriesList[i].countryCode}" selected>${data.countriesList[i].countryName}</option>`;
						dynamicImgHtml += `<img class="icon-${data.countriesList[i].countryName}-flag" src="${data.countriesList[i].countryImage}">`;
					} else {
						dynamicListHtml += `<option value="${data.countriesList[i].countryCode}">${data.countriesList[i].countryName}</option>`;
						dynamicImgHtml += `<img class="icon-${data.countriesList[i].countryName}-flag hide" src="${data.countriesList[i].countryImage}">`
					}
				}
				dynamicListHtml += `</select>`
				$(".catalogue-country-dropdown").append(dynamicListHtml);
				$(".catalogue-flags-svg").append(dynamicImgHtml);
				_self.getCountrySelectedList();
				let dynamicSlides = '';
				let dynamicDots = '';
				if (_self.banId != null && _self.banId != undefined) {
					for (let i = 1; i <= _self.bannerList.length; i++) {
						if (_self.banId == _self.bannerList[i - 1].id) {
							dynamicSlides += `<div class="mySlides" style="display:block"><img class="banner_img" id="${data.bannerList[i - 1].id}" src="${data.bannerList[i - 1].imageURL}" style="width:100%"><div class="text"><span class="banner-text">${data.bannerList[i - 1].name}</span></div></div>`;
						}
					}
					$(".slideshow-container").append(dynamicSlides);
				} else {
					for (let i = 1; i <= _self.bannerList.length; i++) {
						let leng = _self.bannerList.length;
						dynamicSlides += `<div class="mySlides"><div class="numbertext">${i}/${leng}</div><img class="banner_img" id="${data.bannerList[i - 1].id}" src="${data.bannerList[i - 1].imageURL}" style="width:100%"><div class="text"><span class="banner-text">${data.bannerList[i - 1].name}</span></div></div>`;
						dynamicDots += `<span class="dot" id="${i}"></span>`;
						//alert("Id.."+data.bannerList[i].id);
						//alert("name.."+data.bannerList[i].name);
						//alert("imageURL.."+data.bannerList[i].imageURL);
					}
					if (_self.bannerList.length > 1) {
						dynamicSlides += `<a class="prev arrowclick" id="-1"><span>&#129144;</span></a>` +
							`<a class="next arrowclick" id="1"><span>&#10132;</span></a>`
					}
					$(".slideshow-container").append(dynamicSlides);
					$(".dynmamic_dots").append(dynamicDots);
					_self.showSlides(_self.slideIndex);
					_self.plusSlides();
					_self.currentSlide();
					_self.bannerRedirect();
				}
			});
	}
	appendCategories(): void {
		let _self = this;
		var catelogueList = $.Deferred();
		let authenticationUrl: string = '';
		/*$(".catalogue-country-dropdown").append(`<select class="country-dropdown"><option value="MALAYSIA">Malaysia</option><option value="INDIA">India</option><option value="AUSTRALIA">Australia</option><option value="SINGAPORE">Singapore</option></select>`);
				$('select').on('change', function() {
					var dropdownslecetedvalue = $(this).find(":selected").val();
					if(dropdownslecetedvalue == "INDIA"){
						$(".icon-india-flag").removeClass("hide");
						$(".icon-australia-flag").addClass("hide");
						$(".icon-singapore-flag").addClass("hide");
						$(".icon-malaysia-flag").addClass("hide");
					} else if (dropdownslecetedvalue == "AUSTRALIA"){
						$(".icon-australia-flag").removeClass("hide");
						$(".icon-singapore-flag").addClass("hide");
						$(".icon-malaysia-flag").addClass("hide");
						$(".icon-india-flag").addClass("hide");
					} else if (dropdownslecetedvalue == "SINGAPORE"){
						$(".icon-singapore-flag").removeClass("hide");
						$(".icon-malaysia-flag").addClass("hide");
						$(".icon-india-flag").addClass("hide");
						$(".icon-australia-flag").addClass("hide");
					} else if (dropdownslecetedvalue == "MALAYSIA"){
						$(".icon-malaysia-flag").removeClass("hide");
						$(".icon-australia-flag").addClass("hide");
						$(".icon-singapore-flag").addClass("hide");
						$(".icon-india-flag").addClass("hide");
					}
				  });*/
		// _self.bookingformcommon.preloader();
		let redmCountry = $('#mh-country-dropdown').find(":selected").val();
		if (redmCountry != null && redmCountry != '' && redmCountry != undefined) {

		} else {
			redmCountry = _self.mhCountry;
		}
		let searchItem = $('#search-input-header').val();
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			authenticationUrl = '/dummy-data/enrich-catelogue.json';
		}
		else {
			authenticationUrl = '/bin/services/new/getCatalogueAllList?mhCountry=' + redmCountry + '&searchItem=' + searchItem + '&banId=' + _self.banId;
		}
		$.get(authenticationUrl)
			.done((data: any) => {
				if (typeof data === 'string') {
					data = JSON.parse(data);
				}
				const categoriesList = data['mhCategryList'];

				if (categoriesList) {
					$(".categories-section").append(`<div class="category-listitem-zero col-sm-12 col-lg-12 col-md-12 col-xs-12"><h4>Categories</h4></div>`);
					var list = $(".category-listitem-zero").append('<ul class="mhCategory-ul col-sm-12 col-lg-12 col-md-12 col-xs-12"></ul>').find('ul');
					categoriesList.forEach((category: any, categoryIndex: number) => {
						if ((category.code).toLowerCase() == 'all' || (category.code).toLowerCase() == 'hot24deals') {
							list.append(`<li class="category-items category-for-all" id="${category.code}"><a href="#"><img class='col-md-4 icon-image' src='${category.iconURL}'><span class="category-text">${category.title}</span></a></li>`);
						}
					});

					categoriesList.forEach((category: any, categoryIndex: number) => {
						if ((category.code).toLowerCase() !== 'all' && (category.code).toLowerCase() !== 'hot24deals') {
							list.append(`<li class="category-items category-for-all" id="${category.code}"><a href="#"><img class='col-md-4 icon-image' src='${category.iconURL}'><span class="category-text">${category.title}</span></a></li>`);
						}
					});

					const keyList = Object.keys(data);

					keyList.forEach((voucherItem, index) => {
						if (voucherItem.toLocaleLowerCase() == 'hot24deals') {
							const title = voucherItem.replace("24", " ");
							const ttl = title.replace("26", "&");
							const title1 = ttl.replace("24", " ");
							$(".categories-section").append(`<div class="category-listitem-one" id="category-${voucherItem}"><h4>${title1}</h4></div>`);
							//<p class="category-view-all category-view-all-one hide" id="viewall-${voucherItem}"><a href="#">View all</a></p>
							const voucherData = data[voucherItem];
							var list = $(`#category-${voucherItem}`).append('<ul class="mhprivilege-ul carousel for-carousel col-sm-12 col-lg-12 col-md-12" id="mh-voucher-list"></ul>').find('ul');
							voucherData.forEach((voucher: any, vIndex: any) => {
								list.append(`<li class="category-items for-mhvouchers voucher-detail col-sm-3 col-lg-3 col-md-3" id="${voucher.vouchId}"><a href="" class="item"><img class='col-md-4 icon-image' src='${voucher.thumbNlImg}'><span class="category-text col-sm-4 col-xs-4 col-md-4">${voucher.vouchName}</span><span class="voucher-des col-sm-4 col-xs-4 col-md-4" data-maxlength="47">${voucher.vouchDesc}</span><hr><span class="voucher-price col-sm-4 col-xs-4 col-md-4">${voucher.vouchPrice}</span></a></li>`);
							})
						}
					})

					keyList.forEach((voucherItem, index) => {
						if (voucherItem !== 'mhCategryList' && voucherItem.toLocaleLowerCase() !== 'hot24deals' && voucherItem !== 'status') {
							const title = voucherItem.replace("24", " ");
							const ttl = title.replace("26", "&");
							const title1 = ttl.replace("24", " ");
							if (_self.banId != null && _self.banId != undefined && _self.banId != '') {
								$(".categories-section").append(`<div class="category-listitem-one" id="category-${voucherItem}"></div>`);
								const voucherData = data[voucherItem];
								var list = $(`#category-${voucherItem}`).append('<ul class="mhprivilege-ul carousel for-carousel col-sm-12 col-lg-12 col-md-12" id="mh-voucher-list"></ul>').find('ul');
								voucherData.forEach((voucher: any, vIndex: any) => {
									list.append(`<li class="category-items for-mhvouchers voucher-detail col-sm-3 col-lg-3 col-md-3" id="${voucher.vouchId}"><a href="" class="item"><img class='col-md-4 icon-image' src='${voucher.thumbNlImg}'><span class="category-text col-sm-4 col-xs-4 col-md-4">${voucher.vouchName}</span><span class="voucher-des col-sm-4 col-xs-4 col-md-4" data-maxlength="47">${voucher.vouchDesc}</span><hr><span class="voucher-price col-sm-4 col-xs-4 col-md-4">${voucher.vouchPrice}</span></a></li>`);
								})
							} else {
								$(".categories-section").append(`<div class="category-listitem-one" id="category-${voucherItem}"><h4>${title1}</h4></div>`);
								//<p class="category-view-all category-view-all-one hide" id="viewall-${voucherItem}"><a href="#">View all</a></p>

								const voucherData = data[voucherItem];
								if (voucherData.length > 0) {
									var list = $(`#category-${voucherItem}`).append('<ul class="mhprivilege-ul carousel for-carousel col-sm-12 col-lg-12 col-md-12" id="mh-voucher-list"></ul>').find('ul');
									voucherData.forEach((voucher: any, vIndex: any) => {
										if (voucher.errMsg) {
											list.append(`<p class="no-vouchers">${voucher.errMsg}</p>`);
											$(`#category-${voucherItem}`).addClass("no_vouch_catg");
											$(`#category-${voucherItem}`).addClass("hide");
										} else {
											list.append(`<li class="category-items for-mhvouchers voucher-detail padding-space col-sm-3 col-lg-3 col-md-3" id="${voucher.vouchId}"><a href="" class="item"><img class='col-md-4 icon-image' src='${voucher.thumbNlImg}'><span class="category-text col-sm-4 col-xs-4 col-md-4">${voucher.vouchName}</span><span class="voucher-des col-sm-4 col-xs-4 col-md-4" data-maxlength="47">${voucher.vouchDesc}</span><hr><span class="voucher-price col-sm-4 col-xs-4 col-md-4">${voucher.vouchPrice}</span></a></li>`);
										}
									})
								} else {
									var list = $(`#category-${voucherItem}`).append('<ul class="mhprivilege-ul carousel for-carousel col-sm-12 col-lg-12 col-md-12" id="mh-voucher-list"></ul>').find('ul');
									list.append(`<p class="no-vouchers"> Sorry, there's no active voucher for this category </p>`);
								}
							}
						}
					})
				}
				const voucherListItem = $(".category-listitem-one");
				voucherListItem.each(function (itemCount: any, categorytest: any) {
					const itemCountLength = $(categorytest).children().find('li');
					const categoryId = $(categorytest).attr('id').split('-')[1];
					const categoryDivId = 'category-' + categoryId;
					const count = 3;
					itemCountLength.each(function (itemCount1: any, liItems: any) {
						// if(itemCount1>2){
						// 	$("#" + categoryDivId).find(".category-view-all").removeClass('hide');
						// } else {
						// 	$("#" + categoryDivId).find(".category-view-all").addClass('hide');
						// }
						if (_self.banId != null && _self.banId != undefined && _self.banId != '') {
							$(this).removeClass("hide");
						} else {
							if (itemCount1 > 2) {
								//$(this).addClass("hide");
								$("#" + categoryDivId).find(".category-view-all").removeClass('hide');
								// $(this).parent().append(`<span class="fa fa-arrow-right"></span>`)
							} else {
								$("#" + categoryDivId).find(".category-view-all").addClass('hide');
							}
						}
						const voucherListItemArrow = $(".fa-arrow-right");
						$(voucherListItemArrow).on("click", function (event: any) {
							const itemCountLength = $(categorytest).children().find('li');
							$(".fa-arrow-right").addClass("hide");
							itemCountLength.each(function (itemCount1: any, liItems: any) {
								if (itemCount1 > 2) {
									$(this).removeClass("hide");
									$(".fa-arrow-right").addClass("hide");
								}
							});
							const clickedArrowId = $(this).parents("ul").parent("div").attr("id");
							const voucherList = $(".category-listitem-one");
							voucherList.each(function (voucherIndex: any, voucherCategory: any) {
								const voucherListId = $(voucherCategory).attr('id');
								if (clickedArrowId !== voucherListId) {
									$(voucherCategory).addClass('hide');
								}
								$('.category-for-all').each(function (childIndex1: any, childItem1: any) {
									const tsett = $(this).attr('id');
									// const clickedArrowSplitID = $(voucherCategory).attr('id').split('-')[1];
									if ("category-" + $(this).attr('id') === clickedArrowId) {
										$(`#${$(childItem1).attr('id')}`).addClass('active');
									} else {
										$(`#${$(childItem1).attr('id')}`).removeClass('active');
									}
								});
							});
						});
					});
					// $(".item").addClass("hide");
					// if(itemCountLength > count){
					// 	$(".item").slice(0, 3).removeClass("hide"); // select the first ten
					// 	$("#load").click(function(e:any) { // click event for load more
					// 		e.preventDefault();
					// 		$(".item:hidden").slice(0, 3).show(); // select next 10 hidden divs and show them
					// 		if ($(".item:hidden").length == 0) { // check if any hidden divs still exist
					// 		alert("No more divs"); // alert if there are none left
					// 		}
					// 	});
					// }
				});
				// const viewAllForSpacing = $(".category-view-all");
				// viewAllForSpacing.each(function(viewAllCount: any, viewAllCategory:any){
				// 	if($(viewAllCategory).hasClass("hide")){
				// 		$(this).find(".for-carousel").css("margin-top", "17px !important");
				// 	} else {
				// 		$(this).find(".for-carousel").css("margin-top", "-17px");
				// 	}
				// });

				const voucherList = $(".category-listitem-one");
				$(".category-for-all").each(function (itemIndex: any, categoryItem: any) {
					$('#All').addClass("active");
					$(categoryItem).on("click", function (event: any) {
						event.preventDefault();
						$(".category-listitem-one").addClass("hide");
						const clickedId = $(this).attr("id");
						const viewAllId = "viewall-" + clickedId;
						if (clickedId.toLowerCase() === "all") {
							voucherList.each(function (voucherIndex: any, voucherCategory: any) {
								$(voucherCategory).removeClass('hide');
								$(`#${viewAllId}`).removeClass("hide");
								const itemCountLength1 = $(voucherCategory).children().find('li');
								const categoryId = $(voucherCategory).attr('id').split('-')[1];
								const categoryDivId = 'category-' + categoryId;
								itemCountLength1.each(function (itemCount3: any, liItems3: any) {
									if (itemCount3 > 2) {
										//$(this).addClass("hide");
										$(".fa-arrow-right").removeClass("hide");
										$("#" + categoryDivId).find(".category-view-all").removeClass('hide');
										// $(this).parent().append(`<span class="fa fa-arrow-right"></span>`)
									} else {
										$("#" + categoryDivId).find(".category-view-all").addClass('hide');
									}
								});
								if (itemCountLength1.length == 0) {
									$("#" + categoryDivId).addClass('hide');
								}
							});
							// const viewAllList1 = $(".category-view-all");
							// viewAllList1.each(function(voucherIndex: any, viewAllCategory:any){
							// 	$(viewAllCategory).removeClass('hide');
							// });
							$('.category-for-all').each(function (childIndex: any, childItem: any) {
								if ($(childItem).attr('id').toLowerCase() === 'all') {
									$('#All').addClass('active');
									$(`#${viewAllId}`).removeClass("hide");
								} else {
									$(`#${$(childItem).attr('id')}`).removeClass('active')
								}
							});
						} else {
							const voucherCategoryId = "category-" + clickedId;
							$('.category-for-all').each(function (childIndex: any, childItem: any) {
								if ($(this).attr('id') === clickedId) {
									$(`#${clickedId}`).addClass('active');
									$(`#${viewAllId}`).removeClass("hide");
								} else {
									$(`#${$(childItem).attr('id')}`).removeClass('active');
									$(`#${viewAllId}`).addClass("hide");
								}
							});

							voucherList.each(function (voucherIndex: any, voucherCategory: any) {
								let voucherCategoryListId = $(voucherCategory).attr('id');
								if (voucherCategoryListId !== voucherCategoryId) {
									$(voucherCategory).addClass('hide');
								} else if (voucherCategoryListId === voucherCategoryId) {
									$(voucherCategory).removeClass('hide');
									$(`#${viewAllId}`).addClass("hide");
									const itemCountLength = $(voucherCategory).children().find('li');
									itemCountLength.each(function (itemCount2: any, liItems1: any) {
										if (itemCount2 > 2) {
											$(this).removeClass("hide");
											$(".fa-arrow-right").addClass("hide");
										}
									});
								}
							});
						}
					})
				});
				const viewAllList = $(".category-view-all");
				viewAllList.each(function (viewIndex: number, viewItem: any) {
					$(viewItem).on('click', function (event: any) {
						event.preventDefault();
						const categoryId = $(viewItem).attr('id').split('-')[1];
						const categoryDivId = 'category-' + categoryId;
						const clickedViewItemId = $(viewItem).attr('id').split('-')[1];
						$('.category-for-all').each(function (childIndex1: any, childItem1: any) {
							if ($(this).attr('id') === clickedViewItemId) {
								$(`#${clickedViewItemId}`).addClass('active');
							} else {
								$(`#${$(childItem1).attr('id')}`).removeClass('active');
							}
						});
						// $(`#${categoryDivId}`).addClass("hide");

						// const keyList = Object.keys(data);
						// keyList.forEach((voucherItem:any, index:any) => {
						// 	if(voucherItem === categoryId){
						// 		$(".categories-section").append(`<div class="category-listitem-one" id="category1-${voucherItem}"><h4>${voucherItem}</h4><p class="category-view-all category-view-all-one" id="viewall-${voucherItem}"><a href="#">View all</a></p></div>`);
						// 		const voucherData = data[voucherItem];
						// 		var list1 = $(`#category1-${voucherItem}`).append('<ul class="mhprivilege-ul carousel col-sm-12 col-lg-12 col-md-12" id="mh-voucher-list"></ul>').find('ul');
						// 		voucherData.forEach((voucher:any, vIndex:any) => {
						// 			list1.append(`<li class="category-items for-mhvouchers voucher-detail col-sm-3 col-lg-3 col-md-3" id="${voucher.vouchId}"><a href=""><img class='col-md-4 icon-image' src='${voucher.thumbNlImg}'><span class="category-text col-sm-4 col-xs-4 col-md-4" data-maxlength="10">${voucher.vouchName}</span><span class="voucher-des col-sm-4 col-xs-4 col-md-4" data-maxlength="30">${voucher.vouchDesc}</span><hr><span class="voucher-price col-sm-4 col-xs-4 col-md-4">${voucher.vouchPrice}</span></a></li>`);
						// 			$(voucherData).addClass("active");
						// 		})
						// 	}
						// })
						voucherList.each(function (voucherIndex: any, voucherCategory: any) {
							const voucherListId = $(voucherCategory).attr('id');
							if (voucherListId !== categoryDivId) {
								$(voucherCategory).addClass('hide');
							} else {
								const itemCountLength = $(voucherCategory).children().find('li');
								itemCountLength.each(function (itemCount1: any, liItems: any) {
									if (itemCount1 > 2) {
										$(this).removeClass("hide");
										$(".category-view-all").addClass("hide");
										$(".fa-arrow-right").addClass("hide");
									}
								});
							}
						});

					});

				});
				if (_self.banId != null && _self.banId != undefined && _self.banId != '') {
					$(".category-listitem-zero").addClass("hideclass");
					$(".category-listitem-zero").removeClass("showclass");
				} else {
					$(".category-listitem-zero").removeClass("hideclass");
					$(".category-listitem-zero").addClass("showclass");
				}

				// $('.for-carousel').slick({
				// 	infinite: false,
				// 	speed: 300,
				// 	slidesToShow: 5,
				// 	slidesToScroll: 1,
				// 	arrows: true,
				// 	dots: false,
				// 	responsive: [
				// 		{
				// 			breakpoint: 1200,
				// 			settings: {
				// 				infinite: false,
				// 				speed: 300,
				// 				slidesToShow: 3,
				// 				slidesToScroll: 2,
				// 				settings: "unslick",
				// 				// dots: true
				// 			}
				// 		},
				// 		{
				// 			breakpoint: 767,
				// 			settings: {
				// 				slidesToShow: 1,
				// 				slidesToScroll: 1,
				// 				settings: "unslick",
				// 				// dots: true
				// 			}
				// 		}
				// 		// You can unslick at a given breakpoint now by adding:
				// 		// settings: "unslick"
				// 		// instead of a settings object
				// 	]
				// });
				$('.for-carousel').slick({
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 1,
					responsive: [
						{
							breakpoint: 991,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 1,
								infinite: false,
								dots: false
							}
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
						// You can unslick at a given breakpoint now by adding:
						// settings: "unslick"
						// instead of a settings object
					]
				});
				// $('.dummy2').slick({
				// 	// infinite: false,
				// 	// speed: 300,
				// 	// slidesToShow: 3,
				// 	// slidesToScroll: 3,
				// 	arrows: false,
				// 	dots: false,
				// 	responsive: [
				// 		{
				// 			breakpoint: 1200,
				// 			settings: "unslick"
				// 		},
				// 		{
				// 			breakpoint: 767,
				// 			settings: "unslick"
				// 		}
				// 		// You can unslick at a given breakpoint now by adding:
				// 		// settings: "unslick"
				// 		// instead of a settings object
				// 	]
				// });
				_self.voucherDetailView();
				_self.textLimit();

			})
			.fail((error: any) => {
				catelogueList.reject(error)
			});
	}
	voucherDetailView(): void {
		let _self = this;
		$(".voucher-detail").click(function ($instance: any) {
			$instance.preventDefault();
			let vouchMaxLimit: any;
			let data = {
				clickedID: $(this).attr('id'),
			};
			let authenticationUrl: string = '';
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				authenticationUrl = '/dummy-data/enrich-catelogue.json';
			}
			else {
				authenticationUrl = '/bin/services/new/getIndivVoucherDtls';
			}
			_self.bookingformcommon.preloader();
			$.ajax({
				type: 'POST',//Change to POST if required
				url: authenticationUrl,
				data: data,
				success: function (data: any) {
					_self.bookingformcommon.preloaderClose();
					if (data != "") {
						let json: any = null;
						if (typeof data === 'string') {
							json = JSON.parse(data);
						} else {
							json = data;
						}
						_self.initialBal = json.currentBalance;
						_self.voucherRedemList = json.voucherList;
						_self.vouchLimit = json.redemQtyLimit;
						_self.vouchCategry = json.vouchType;


						$("#member-enrich-newcatalogue").removeClass("showclass");
						$("#member-enrich-newcatalogue").addClass("hideclass");
						$("#member-enrich-voucherdetailcatalogue").removeClass("hideclass");
						$("#member-enrich-voucherdetailcatalogue").addClass("showclass");
						$("#redirect_home").removeClass("hideclass");
						$("#redirect_home").addClass("showclass");
						$(".voucher-quantity-incre-decre").attr("data-max", json.redemQtyLimit);
						$(".voucher-image").attr("src", json.vouchImage);
						$('.vouch_title').text(json.vouchTitle);
						$('#vouch_desc').text(json.vouchDesc);
						$('.voucher-points').text(json.vouchEndDate);
						if (json.findOutmore != null && json.findOutmore != "") {
							//alert("if findOutmore");
							$(".find_more").attr('href', json.findOutmore);
						} else {
							//alert("else findOutmore");
							$('#findOutMore').addClass("hideclass");
						}
						if (json.howToUse != null && json.howToUse != "") {
							//alert("if howToUse");
							$('.how-to-use-list').html(json.howToUse);
						} else {
							//alert("else howToUse");
							$('#howToUse').addClass("hideclass");
						}
						if (json.termsAndCondi != null && json.termsAndCondi != "") {
							//alert("if termsAndCondi");
							$('.terms-and-condition-list').html(json.termsAndCondi);
						} else {
							//alert("else termsAndCondi");
							$('#tNc').addClass("hideclass");
						}
						if (json.progrBarVal != null && json.progrBarVal >= 0) {
							updateProgress(json.progrBarVal);
							$("#range-slider-text").html(json.redemedCount + " REDEEMED");
						} else {
							$("#progress_bar").addClass("hide");
						}

						if (json.vouchType != null && json.vouchType == "packageVoucher") {
							$("#bundle_pkg_disp").removeClass("showclass");
							$("#bundle_pkg_disp").addClass("hideclass");
							$("#pkg_optn_disp").removeClass("hideclass");
							$("#pkg_optn_disp").addClass("showclass");
							let dynamicListHtml = '';
							for (let i = 0; i < _self.voucherRedemList.length; i++) {
								if (i == 0) {
									dynamicListHtml += `<span class="domestic col-sm-3 active" id="${_self.voucherRedemList[i].redemID}"><label class="dom-label">${_self.voucherRedemList[i].redmName}</label><label class="col-sm-4 col-md-4 col-xs-4 domestic-points">${_self.voucherRedemList[i].redemDisplPts}</label></span>`;
									$('.voucher-points').text(_self.voucherRedemList[i].redmExpDate);
									$('#vouch_desc').text(_self.voucherRedemList[i].redemDesc);
									if (_self.voucherRedemList[i].redemProgBar != null && _self.voucherRedemList[i].redemProgBar >= 0) {
										updateProgress(_self.voucherRedemList[i].redemProgBar);
										$("#range-slider-text").html(_self.voucherRedemList[i].redemedCount + " REDEEMED");
										$("#progress_bar").removeClass("hide");
									} else {
										$("#progress_bar").addClass("hide");
									}
								} else {
									dynamicListHtml += `<span class="domestic col-sm-3" id="${_self.voucherRedemList[i].redemID}"><label class="dom-label">${_self.voucherRedemList[i].redmName}</label><label class="col-sm-4 col-md-4 col-xs-4 domestic-points">${_self.voucherRedemList[i].redemDisplPts}</label></span>`;
								}
							}
							let finalHtml = `<div class="voucher-denominations"><label class="voucher-desc-label-total col-sm-12 col-md-12 col-xs-12">Package option </label>` + dynamicListHtml + `</div>`
							let elm = $('.voucher-des-scetion').find('#pkg_optn_disp');
							elm.html(finalHtml);
							_self.handleRedemptionChange();
						}
						else {
							$("#pkg_optn_disp").removeClass("showclass");
							$("#pkg_optn_disp").addClass("hideclass");
							if (json.vouchType != null && json.vouchType == "bundleVoucher") {
								$("#bundle_pkg_disp").removeClass("hideclass");
								$("#bundle_pkg_disp").addClass("showclass");
								$("#progress_bar").addClass("hide");
								let dynamicListHtml = '';
								for (let i = 0; i < json.bundleList.length; i++) {
									if (i == 0) {
										dynamicListHtml += `<a href=""><span class="voucher-detail bundle-image col-sm-3" id="${json.bundleList[i].bundleId}"><img class="bundle-voucher-image" src="${json.bundleList[i].bundleImg}"></div></span></a>`;
									} else {
										dynamicListHtml += `<span class="bundle-option col-sm-3">    <i class="fa fa-plus" aria-hidden="true">   </i></span> <a href=""><span class="voucher-detail bundle-image1 col-sm-3" id="${json.bundleList[i].bundleId}"><img class="bundle-voucher-image1" src="${json.bundleList[i].bundleImg}"></div></span></a>`;
									}
								}
								let finalHtml = `<label class="voucher-desc-label-total col-sm-12 col-md-12 col-xs-12">Bundle option </label>` + dynamicListHtml;
								let elm = $('.voucher-des-scetion').find('#bundle_pkg_disp');
								elm.html(finalHtml);
								_self.voucherDetailView();
							} else {
								$("#bundle_pkg_disp").removeClass("showclass");
								$("#bundle_pkg_disp").addClass("hideclass");
							}
							//_self.getVoucherTypeValues(_self.initialBal,_self.voucherList,"0",json.redemQtyLimit,"0");
						}
						if (parseInt(_self.initialBal) < 0) {
							$("insuff_pts_err_msg").addClass("showclass");
							$('#voucher-redeem--button').attr('disabled', true);
							if (!$(".redeem-incrementer").hasClass("disablee")) {
								$(".redeem-incrementer").addClass("disablee");
							}
							if (!$(".redeem-decremeneter").hasClass("disablee")) {
								$(".redeem-decremeneter").addClass("disablee");
							}
						} else {
							for (let i = 1; i <= _self.voucherRedemList.length; i++) {
								$('.voucher-desc-points').text(_self.voucherRedemList[0].redemDisplPts);
								$('.redeemId').val(_self.voucherRedemList[0].redemID);
								$('.redeem_inital_value').val(_self.voucherRedemList[0].redemVal);
								if (parseInt(_self.initialBal) < parseInt(_self.voucherRedemList[0].redemVal)) {
									$("insuff_pts_err_msg").addClass("showclass");
									$('#voucher-redeem--button').attr('disabled', true);
									if (!$(".redeem-incrementer").hasClass("disablee")) {
										$(".redeem-incrementer").addClass("disablee");
									}
									if (!$(".redeem-decremeneter").hasClass("disablee")) {
										$(".redeem-decremeneter").addClass("disablee");
									}
								}
							}
						}
						// _self.redirectToHome();
						_self.initIncrementer();
						_self.textReadMore();
					}
				},
				error: function (error: any) {
					_self.bookingformcommon.preloaderClose();
					$('body').animate({
						'scrollTop': 100
					}, 500, function () { });
				}
			});
		});
	}
	accordionHowToUse(): void {
		$(".voucher-how-to, .voucher-use, .terms-and-condition, .voucher-termandcondition").click(function () {
			$(this).next().slideToggle()
				.siblings("div:visible").slideUp();
		});
	}
	iconToggle(): void {
		$('.voucher-use').click(function () {
			if ($(this).find('#angleupicon').hasClass('fa-angle-down')) {
				$('#angleupicon').addClass('fa-angle-down');
				$(this).find('#angleupicon').removeClass('fa-angle-down').addClass('fa-angle-up');
			} else {
				$(this).find('#angleupicon').addClass('fa-angle-up').removeClass('fa-angle-down');
			}
		});
	}
	textLimit(): void {
		$(".voucher-des").text(function (index: any, currentText: any) {
			var maxLength = $(this).attr('data-maxlength');
			if (currentText.length >= maxLength) {
				return currentText.substr(0, maxLength) + "...";
			} else {
				return currentText
			}
		});
		//   $(".readmore-text").click(function(e:any){
		// 	$(this).removeAttr("data-maxlength");
		// 	// e.preventDefault();
		//   });
	}
	textReadMore(): any {
		//alert("in textread more");
		let descriptionTextContent: any;
			//if($("#member-enrich-voucherdetailcatalogue").hasClass(".showclass")){
			$(".bundle-des").text(function (index: any, currentText: any) {
				//alert("in textread more"+currentText);
				descriptionTextContent = currentText;
				var maxLength = $(this).attr('data-maxlength');
				if (currentText.length >= maxLength) {
					$(".readmore-text").removeClass("hide");
					return currentText.substr(0, maxLength) + "...";
				} else {
					$(".readmore-text").addClass("hide");
					return currentText
				}
			});
		$(".readmore-text").click(function (e: any) {
			//alert("onclick");
			$(".bundle-des").text(function (index: any, currentText: any) {
				//alert("currentText..."+currentText);
				var maxLength = $(".bundle-des").attr('data-maxlength');
				if (descriptionTextContent.length >= maxLength) {
					$(".readmore-text").addClass("hide");
					return descriptionTextContent;
				} else {
					$(".readmore-text").addClass("hide");
					return descriptionTextContent
				}
			});
		});
	//}
	}
	/*redeemRange(): void{
		function updateProgress(progress:any) {
			const progressBar = document.getElementById('range-slider');
			progressBar.style.width = `${progress}%`;
		}

		// Example: Update progress to 50%
		updateProgress(60);
	}*/
	initIncrementer(): any {

		let _self = this;
		let inputElArr: any = $.makeArray(_self.catelogueForm.find('.voucher-quantity-incre-decre'));
		_self.setIntialIncreamentVal(inputElArr, "N");
		//_self.memberBase.initIncrementer(inputElArr);
	}
	setIntialIncreamentVal(inputElArr: any, cartId: any): any {
		let _self = this;
		for (var i = 0, len = inputElArr.length; i < len; i++) {
			let el = $(inputElArr[i]);
			let btnMinus = el.find('.redeem-decremeneter');
			let btnPlus = el.find('.redeem-incrementer');
			let elDisplay = el.find('.redeem-value');
			let input = el.find('input[type="hidden"]');
			//let curVal:number = 0;
			let params = {
				'min': parseInt(el[0].dataset.min),
				'max': parseInt(el[0].dataset.max),
				'initvalue': parseInt(el[0].dataset.initValue)
			};
			// btnMinus click handler
			// - on click, increment display value & input[hidden] value
			btnMinus.on('click', function (e: any) {
				e.preventDefault();
				e.stopPropagation();
				cartId = "N";
				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(25);
				}
				_self.incrementDisplayValue = setIncrementer(elDisplay, input, _self.incrementDisplayValue, params, 'decrement');
				//alert("on decrement>>"+curVal);
			});

			// btnMinus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnMinInterval: any;

			/*btnMinus.on('mousedown', function(e:any) {
				e.preventDefault();
				e.stopPropagation();
				cartId="N";
				btnMinInterval = setInterval(function() {
					_self.incrementDisplayValue = setIncrementer(elDisplay, input, _self.incrementDisplayValue, params, 'decrement');
				}, 200);
			}).on('mouseup mouseleave', function() {
				clearInterval(btnMinInterval);
			});*/

			// btnPlus click handler
			// - on click, increment display value & input[hidden] value
			btnPlus.on('click', function (e: any) {
				e.preventDefault();
				e.stopPropagation();
				cartId = "N";
				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(35);
				}
				_self.incrementDisplayValue = setIncrementer(elDisplay, input, _self.incrementDisplayValue, params, 'increment');
				//alert("on increment>>"+curVal);
			});

			// btnPlus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnPlusInterval: any;
			/*btnPlus.on('mousedown', function(e:any) {
				e.preventDefault();
				e.stopPropagation();
				cartId="N";
				// set initial delay (500ms)
				btnPlusInterval = setInterval(function() {
					_self.incrementDisplayValue = setIncrementer(elDisplay, input, _self.incrementDisplayValue, params, 'increment');
				}, 200);
			}).on('mouseup mouseleave', function() {
				clearInterval(btnPlusInterval);
			});*/
			if (cartId == "Y") {
				if (i < len) {
					_self.incrementDisplayValue = setIncrementer(elDisplay, input, 1, params, 'inc');
				} else {
					cartId = "N";
				}

			}
			_self.initSelectizeInputs();
		}
	}
	initSelectizeInputs(): any {
		let _self = this;

		let incremeterInput = _self.catelogueForm.find('.voucher-quantity');
		let defer = $.Deferred();

		// when incrementer value changes
		incremeterInput.on('voucher-quantity-incre-decre.changed', function (e: any, val: any) {
			let selectedVoucher = e.target.id;
			console.log(e);
			let rm50TotMiles = 0;
			let totMilesValue = 0;
			let voucherUnit1 = 0;
			let rm50Voucher = 0;
			let rmCount1 = 0;
			let voucherUnitCount = 0;
			let firstIndex = 0;
			let totVocherRedemed = 0;
			let redemBalValues = 0;
			let totVal = 0;
			let totalVouchersBalance = 0;
			// let max_voucher_count_all=0;
			//alert("initial balance"+_self.initialBal);
			//alert("initial vouchLimit"+_self.vouchLimit);
			let redeemBalance = _self.initialBal;
			let totalInput = _self.catelogueForm.find('.voucher-desc-points');
			//var shoppingCartActive  = $(".voucher_desp.active a").attr('id');
			//let max_voucher_count = $("#max_voucher_count").val();
			// var max_voucher_count_all = $(".voucher_desp.active input:hidden[class='max_voucher_count']").val();
			//var max_voucher_count_on_inc = $(".voucher_desp.active input:hidden[class='max_voucher_per_transaction']").val();
			//let max_voucher_count_on_inc = parseInt(_self.vouchLimit);

			var eligibilityFlag = "true"
			firstIndex = parseInt(_self.initialBal);
			totVocherRedemed = 0;//parseInt(_self.totalVocherRedeemed);
			//totalVouchersBalance=parseInt(_self.totalVouchersBalance);
			totalVouchersBalance = 0;
			//max_voucher_count_on_inc = totalVouchersBalance<max_voucher_count_on_inc? totalVouchersBalance:max_voucher_count_on_inc;
			let voucherListIncr = _self.voucherRedemList;
			//var redeemBal = _self.catelogueForm.find( '#partner-redeem--voucher-current-balance').text();
			if (parseInt(_self.initialBal) >= 0) {
				//getIncreamentVoucherDtls(json);
				for (let i = 1; i <= voucherListIncr.length; i++) {
					let countVoucher = _self.catelogueForm.find('#partner-redeem--voucher-type1input').val();
					let redemId = _self.catelogueForm.find('.redeemId').val();
					//("redemId..."+redemId);
					let countVal = 0;
					if (countVoucher != "") {
						//alert("countVoucher"+countVoucher);
						countVal = parseInt(countVoucher);
						//alert("countVal"+countVal);
						if (redemId == voucherListIncr[i - 1].redemID) {
							voucherUnit1 = countVal;
							rm50Voucher = parseInt(voucherListIncr[i - 1].redemVal);
							rmCount1 = parseInt(voucherListIncr[i - 1].AwardCount);
							//alert("rm50Voucher"+rm50Voucher);
							break;
						}
					}
					//voucherUnitCount=voucherUnitCount+countVal;
				}
				voucherUnitCount = voucherUnit1;
				if (totVocherRedemed > 0) {
					voucherUnitCount = totVocherRedemed + voucherUnitCount;
				} else {
					voucherUnitCount = voucherUnitCount - totVocherRedemed;
				}
				//voucherUnit = parseInt(val);
				if (voucherUnitCount <= parseInt(_self.vouchLimit)) {
					//alert("if");
					if (voucherUnit1 <= rmCount1) {
						if (rm50Voucher > 0) {
							rm50TotMiles = voucherUnit1 * rm50Voucher;
						}
					}
					totMilesValue = rm50TotMiles;
					console.log(voucherUnit1, totMilesValue);
					totalInput.val(totMilesValue);
					redemBalValues = parseInt(redeemBalance);
					totVal = parseInt(totalInput.val());
					if (parseInt(_self.initialBal) > totMilesValue) {
						$("#insuff_pts_err_msg").addClass("hideclass");
						$("#insuff_pts_err_msg").removeClass("showclass");
						$('.voucher-desc-points').text(totMilesValue + " Pts");
						$('#voucher-redeem--button').attr('disabled', false);
						if ($(".redeem-incrementer").hasClass("disablee")) {
							$(".redeem-incrementer").removeClass("disablee");
						}
						if ($(".redeem-decremeneter").hasClass("disablee")) {
							$(".redeem-decremeneter").removeClass("disablee");
						}
					} else {
						//$("#limit_control_err_msg").addClass("hideclass");
						//$("#limit_control_err_msg").removeClass("showclass");
						$("#insuff_pts_err_msg").addClass("showclass");
						$("#insuff_pts_err_msg").removeClass("hideclass");
						$('#voucher-redeem--button').attr('disabled', true);
						if (!$(".redeem-incrementer").hasClass("disablee")) {
							$(".redeem-incrementer").addClass("disablee");
						}
					}
					//_self.getVoucherTypeValues(currentBalVal,voucherListIncr,voucherUnitCount,_self.vouchLimit,totalVouchersBalance);
					if (totVal >= 0) {
						//$("#limit_control_err_msg").addClass("hideclass");
						//$("#limit_control_err_msg").removeClass("showclass");
						$("#insuff_pts_err_msg").addClass("hideclass");
						$("#insuff_pts_err_msg").removeClass("showclass");
						$('#voucher-redeem--button').attr('disabled', false);
						if ($(".redeem-incrementer").hasClass("disablee")) {
							$(".redeem-incrementer").removeClass("disablee");
						}
						if ($(".redeem-decremeneter").hasClass("disablee")) {
							$(".redeem-decremeneter").removeClass("disablee");
						}
					} else {
						//$("#limit_control_err_msg").addClass("hideclass");
						//$("#limit_control_err_msg").removeClass("showclass");
						$("#insuff_pts_err_msg").addClass("showclass");
						$("#insuff_pts_err_msg").removeClass("hideclass");
						$('#voucher-redeem--button').attr('disabled', true);
						/*if(!$(".redeem-incrementer").hasClass("disablee"))
						{
							$(".redeem-incrementer").addClass("disablee");
						}*/
						if (!$(".redeem-decremeneter").hasClass("disablee")) {
							$(".redeem-decremeneter").addClass("disablee");
						}
					}
				} else {

					$("#insuff_pts_err_msg").removeClass("showclass");
					$("#insuff_pts_err_msg").addClass("hideclass");
					//$('#voucher-redeem--button').attr('disabled', true);
					if (!$(".redeem-incrementer").hasClass("disablee")) {
						$(".redeem-incrementer").addClass("disablee");
					}
				}
			} else {
				//	$("#limit_control_err_msg").addClass("hideclass");
				//$("#limit_control_err_msg").removeClass("showclass");
				$("#insuff_pts_err_msg").removeClass("hideclass");
				$("#insuff_pts_err_msg").addClass("showclass");
				$('#voucher-redeem--button').attr('disabled', true);
				if (!$(".redeem-incrementer").hasClass("disablee")) {
					$(".redeem-incrementer").addClass("disablee");
				}
				if (!$(".redeem-decremeneter").hasClass("disablee")) {
					$(".redeem-decremeneter").addClass("disablee");
				}
			}

		});
	}
	handleRedemptionChange(): any {
		let _self = this;
		$('#pkg_optn_disp .voucher-denominations span').click(function () {
			$('.voucher-denominations span').removeClass('active');
			$(this).addClass('active');
			let id = $(this).attr("id");
			//alert("Id.."+id);
			$('#partner-redeem--voucher-type1input').val(0);
			$('.redeem-value').html(0);
			for (let i = 0; i < _self.voucherRedemList.length; i++) {
				if (id == _self.voucherRedemList[i].redemID) {
					$('.voucher-points').text(_self.voucherRedemList[i].redmExpDate);
					$('.redeem_inital_value').val(_self.voucherRedemList[i].redemVal);
					$('.voucher-desc-points').text(_self.voucherRedemList[i].redemDisplPts);
					$('.redeemId').val(_self.voucherRedemList[i].redemID);
					$('.vouch_title').val(_self.voucherRedemList[i].redemTitle);
					$('#vouch_desc').text(_self.voucherRedemList[i].redemDesc);
					//updateProgress(_self.voucherRedemList[i].redemProgBar);
					if (_self.voucherRedemList[i].redemProgBar != null && _self.voucherRedemList[i].redemProgBar >= 0) {
						updateProgress(_self.voucherRedemList[i].redemProgBar);
						$("#range-slider-text").html(_self.voucherRedemList[i].redemedCount + " REDEEMED");
						$("#progress_bar").removeClass("hide");
					} else {
						$("#progress_bar").addClass("hide");
					}
					if (parseInt(_self.initialBal) < 0) {
						$("#insuff_pts_err_msg").removeClass("hideclass");
						$("#insuff_pts_err_msg").addClass("showclass");
						$('#voucher-redeem--button').attr('disabled', true);
						if (!$(".redeem-incrementer").hasClass("disablee")) {
							$(".redeem-incrementer").addClass("disablee");
						}
						if (!$(".redeem-decremeneter").hasClass("disablee")) {
							$(".redeem-decremeneter").addClass("disablee");
						}
					} else {
						if ($("#insuff_pts_err_msg").hasClass("showclass")) {
							$("#insuff_pts_err_msg").removeClass("showclass");
							$("#insuff_pts_err_msg").addClass("hideclass");
							$('#voucher-redeem--button').attr('disabled', false);
						}
						if ($("#limit_control_err_msg").hasClass("showclass")) {
							$("#limit_control_err_msg").removeClass("showclass");
							$("#limit_control_err_msg").addClass("hideclass");
						}
						if (parseInt(_self.initialBal) < parseInt(_self.voucherRedemList[i].redemVal)) {
							$("#insuff_pts_err_msg").removeClass("hideclass");
							$("#insuff_pts_err_msg").addClass("showclass");
							$('#voucher-redeem--button').attr('disabled', true);
							if (!$(".redeem-incrementer").hasClass("disablee")) {
								$(".redeem-incrementer").addClass("disablee");
							}
							if (!$(".redeem-decremeneter").hasClass("disablee")) {
								$(".redeem-decremeneter").addClass("disablee");
							}
						}
					}
				}
			}
			let display = $('#incre_decre_qty').find('.redeem-value');
			let input = $('#incre_decre_qty').find('input[type="hidden"]');
			//_self.incrementDisplayValue = setIncrementer(display,input,0,{},'');
			display.html(1);
			input.val(1);
			_self.incrementDisplayValue = 1;
		})
	}
	initRedeemSubmit() {
		let _self = this;
		$("#voucher-redeem--button").click(function () {
			let totPts: any;
			let totRdmCnt: any;
			$('#voucher-redeem--confirm--button').attr('disabled', true);
			let totalPts = _self.catelogueForm.find('.voucher-desc-points').text().trim();
			let redmCount = _self.catelogueForm.find('#voucher-redeem-value').text().trim();
			let redmInitVal = _self.catelogueForm.find('.redeem_inital_value').val();
			let redmVouchTitle = _self.catelogueForm.find('.vouch_title').text().trim();
			let redmVouchDesc = _self.catelogueForm.find('#vouch_desc').text().trim();
			totPts = totalPts.replace(/\D/g, '');
			//alert("totPts.."+totPts);
			totRdmCnt = redmCount.replace(/\D/g, '');
			//alert("totRdmCnt.."+totRdmCnt);
			if (parseInt(totPts) >= 0 && parseInt(totRdmCnt) > 0 && parseInt(_self.initialBal) >= 0) {
				//alert("1st If");
				if (parseInt(totPts) <= parseInt(_self.initialBal)) {
					//alert("2nd If");
					$("#member-enrich-newcatalogue").removeClass("showclass");
					$("#member-enrich-newcatalogue").addClass("hideclass");
					$("#member-enrich-voucherdetailcatalogue").removeClass("showclass");
					$("#member-enrich-voucherdetailcatalogue").addClass("hideclass");
					$("#redirect_home").removeClass("showclass");
					$("#redirect_home").addClass("hideclass");
					$("#member-enrich-confirmRedemption").removeClass("hideclass");
					$("#member-enrich-confirmRedemption").addClass("showclass");
					$("#redirect_prev_page").removeClass("hideclass");
					$("#redirect_prev_page").addClass("showclass");
					$("#member-enrich-successfulRedemption").removeClass("showclass");
					$("#member-enrich-successfulRedemption").addClass("hideclass");
					$(".points").text(_self.initialBal);
					$(".voucher-quantity-points").text(redmCount + " * " + redmInitVal + " Pts");
					$(".voucher-total-points").text(totalPts);
					$("#confirm_title").text(redmVouchTitle);
					$("#confirm_desc").text(redmVouchDesc);
				} else {
					$('#voucher-redeem--button').attr('disabled', true);
					$("#insuff_pts_err_msg").removeClass("hideclass");
					$("#insuff_pts_err_msg").addClass("showclass");
				}
			} else {
				$('#voucher-redeem--button').attr('disabled', true);
				$("#insuff_pts_err_msg").removeClass("hideclass");
				$("#insuff_pts_err_msg").addClass("showclass");
			}
			_self.redirectToPrevPage();
		});
	}
	initConfirmRedeemSubmit() {
		let _self = this;
		$("#voucher-redeem--confirm--button").click(function () {
			let totPts: any;
			let totRdmCnt: any;
			let totalPts = _self.catelogueForm.find('.voucher-desc-points').text().trim();
			let redmCount = _self.catelogueForm.find('#voucher-redeem-value').text().trim();
			let redmInitVal = _self.catelogueForm.find('.redeem_inital_value').val();
			var clickedCheckbox = $("#enrich--form--checkbox");
			//let redmCurrcy=_self.catelogueForm.find('.redeem_currency_value').val();
			let redmCurrcy = $('#mh-country-dropdown').find(":selected").val();
			let redmId = _self.catelogueForm.find('.redeemId').val();
			totPts = totalPts.replace(/\D/g, '');
			//alert("totPts.."+totPts+"--redmCurrcy--"+redmCurrcy);
			totRdmCnt = redmCount.replace(/\D/g, '');
			//alert("totRdmCnt.."+totRdmCnt);
			//alert("redmInitVal.."+redmInitVal);
			//alert("redmId.."+redmId);
			if ((parseInt(totPts) >= 0 && parseInt(totRdmCnt) > 0 && parseInt(_self.initialBal) >= 0) && ((clickedCheckbox.is(":checked")))) {
				//alert("1st If");
				if (parseInt(totPts) <= parseInt(_self.initialBal)) {
					//alert("2nd If");
					_self.bookingformcommon.preloader();
					// let submissonid:any = $("#submissionID").val();
					let data = {
						'vouchId': redmId,
						'vouchQty': redmCount,
						'vouchVal': redmInitVal,
						'vouchCurrcy': redmCurrcy
					};
					$.ajax({
						type: 'POST',//Change to POST if required
						url: '/bin/services/new/submVoucherDtls',
						data: data,
						success: function (msg: any) {
							_self.bookingformcommon.preloaderClose();
							if (msg != "") {
								var json = msg;
								if (typeof msg === 'string') {
									json = JSON.parse(msg);
								}
								if (json.processCode === "OK") {
									$("#confirm_error_msg").removeClass("showclass");
									$("#confirm_error_msg").addClass("hideclass");
									$("#member-enrich-newcatalogue").removeClass("showclass");
									$("#member-enrich-newcatalogue").addClass("hideclass");
									$("#member-enrich-voucherdetailcatalogue").removeClass("showclass");
									$("#member-enrich-voucherdetailcatalogue").addClass("hideclass");
									$("#redirect_home").removeClass("showclass");
									$("#redirect_home").addClass("hideclass");
									$("#member-enrich-confirmRedemption").removeClass("showclass");
									$("#member-enrich-confirmRedemption").addClass("hideclass");
									$("#redirect_prev_page").removeClass("showclass");
									$("#redirect_prev_page").addClass("hideclass");
									$("#member-enrich-successfulRedemption").removeClass("hideclass");
									$("#member-enrich-successfulRedemption").addClass("showclass");
									$(".points-balance").text(json.totPtsBal);
									$(".date-year").text(json.currDate);
									$(".points").text(json.totPtsRedemed);
									let navMilesVal = json.totPtsBal;
									$(".miles-value").text(numeral(navMilesVal).format('0,0'));
									document.cookie = "milesCount=" + numeral(navMilesVal).format('0,0') + ";path=/";
									document.cookie = "milesIndentation=" + numeral(navMilesVal).format('0,0') + ";path=/";
								} else {
									$("#confirm_error_msg").text(json.succMsg);
									$("#confirm_error_msg").removeClass("hideclass");
									$("#confirm_error_msg").addClass("showclass");

								}
							}
						},
						error: function (error: any) {
							_self.bookingformcommon.preloaderClose();
							$('body').animate({
								'scrollTop': 100
							}, 500, function () { });
						}
					});
				} else {
					$("#no_valid_err_msg").removeClass("hideclass");
					$("#no_valid_err_msg").addClass("showclass");
				}
			} else {
				$("#no_valid_err_msg").removeClass("hideclass");
				$("#no_valid_err_msg").addClass("showclass");
			}
		});
	}

	searchCatelogue(): void {
		let _self = this;
		var catelogueList = $.Deferred();
		let authenticationUrl: string = '';
		$("#seach-catelogue").on("click", function (event: any) {
			event.preventDefault();
			$(".category-listitem-one").addClass("hide");
			$(".categories-section-forsearch").empty();
			$(".category-for-all").removeClass("active");
			// $(".category-listitem-two").removeClass("hide");
			let redmCountry = $('#mh-country-dropdown').find(":selected").val();
			let searchItem = $('.catalogue-search-input').find("input").val();
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				authenticationUrl = '/dummy-data/enrich-catelogue.json';
			}
			else {
				authenticationUrl = '/bin/services/new/getCatalogueAllList?mhCountry=' + redmCountry + '&searchItem=' + searchItem;
			}
			$.get(authenticationUrl)
				.done((data: any) => {
					if (typeof data === 'string') {
						data = JSON.parse(data);
					}
					const categoriesList = data['mhCategryList'];

					// if (categoriesList) {
					// $(".categories-section").append(`<div class="category-listitem-zero"><h4>Categories</h4></div>`);
					// var list = $(".category-listitem-zero").append('<ul class="mhCategory-ul"></ul>').find('ul');
					// categoriesList.forEach((category: any, categoryIndex: number) => {
					// 	if ((category.code).toLowerCase() == 'all' || (category.code).toLowerCase() == 'hot24deals') {
					// 		list.append(`<li class="category-items category-for-all" id="${category.code}"><a href="#"><img class='col-md-4 icon-image' src='${category.iconURL}'><span class="category-text">${category.title}</span></a></li>`);
					// 	}
					// });

					// categoriesList.forEach((category: any, categoryIndex: number) => {
					// 	if ((category.code).toLowerCase() !== 'all' && (category.code).toLowerCase() !== 'hot24deals') {
					// 		list.append(`<li class="category-items category-for-all" id="${category.code}"><a href="#"><img class='col-md-4 icon-image' src='${category.iconURL}'><span class="category-text">${category.title}</span></a></li>`);
					// 	}
					// });

					const keyList = Object.keys(data);

					keyList.forEach((voucherItem, index) => {
						if (voucherItem.toLocaleLowerCase() == 'hot24deals') {
							const title = voucherItem.replace("24", " ");
							const ttl = title.replace("26", "&");
							const title1 = ttl.replace("24", " ");
							$(".categories-section-forsearch").append(`<div class="category-listitem-two" id="category1-${voucherItem}"><h4>${title1}</h4></div>`);
							const voucherData = data[voucherItem];
							var list = $(`#category1-${voucherItem}`).append('<ul class="mhprivilege-ul carousel for-carousel col-sm-12 col-lg-12 col-md-12" id="mh-voucher-list1"></ul>').find('ul');
							voucherData.forEach((voucher: any, vIndex: any) => {
								list.append(`<li class="category-items for-mhvouchers voucher-detail col-sm-3 col-lg-3 col-md-3" id="${voucher.vouchId}"><a href="" class="item"><img class='col-md-4 icon-image' src='${voucher.thumbNlImg}'><span class="category-text col-sm-4 col-xs-4 col-md-4">${voucher.vouchName}</span><span class="voucher-des col-sm-4 col-xs-4 col-md-4" data-maxlength="47">${voucher.vouchDesc}</span><hr><span class="voucher-price col-sm-4 col-xs-4 col-md-4">${voucher.vouchPrice}</span></a></li>`);
							})
						}
					})

					keyList.forEach((voucherItem, index) => {
						if (voucherItem !== 'mhCategryList' && voucherItem.toLocaleLowerCase() !== 'hot24deals' && voucherItem !== 'status') {
							const title = voucherItem.replace("24", " ");
							const ttl = title.replace("26", "&");
							const title1 = ttl.replace("24", " ");
							$(".categories-section-forsearch").append(`<div class="category-listitem-two" id="category1-${voucherItem}"><h4>${title1}</h4></div>`);
							const voucherData = data[voucherItem];
							if (voucherData.length > 0) {
								var list = $(`#category1-${voucherItem}`).append('<ul class="mhprivilege-ul carousel for-carousel col-sm-12 col-lg-12 col-md-12" id="mh-voucher-list1"></ul>').find('ul');
								voucherData.forEach((voucher: any, vIndex: any) => {
									if (voucher.errMsg) {
										list.append(`<p class="no-vouchers">${voucher.errMsg}</p>`);
										$(`#category1-${voucherItem}`).addClass("no_vouch_catg");
										$(`#category1-${voucherItem}`).addClass("hide");
									} else {
										list.append(`<li class="category-items for-mhvouchers voucher-detail col-sm-3 col-lg-3 col-md-3" id="${voucher.vouchId}"><a href="" class="item"><img class='col-md-4 icon-image' src='${voucher.thumbNlImg}'><span class="category-text col-sm-4 col-xs-4 col-md-4">${voucher.vouchName}</span><span class="voucher-des col-sm-4 col-xs-4 col-md-4" data-maxlength="47">${voucher.vouchDesc}</span><hr><span class="voucher-price col-sm-4 col-xs-4 col-md-4">${voucher.vouchPrice}</span></a></li>`);
									}
								})
							} else {
								var list = $(`#category-${voucherItem}`).append('<ul class="mhprivilege-ul carousel for-carousel col-sm-12 col-lg-12 col-md-12" id="mh-voucher-list"></ul>').find('ul');
								list.append(`<p class="no-vouchers"> Sorry, there's no active voucher for this category </p>`);
							}
						}
					})
					_self.voucherDetailView();
					_self.textLimit();
					// }
				})
				.fail((error: any) => {
					catelogueList.reject(error)
				});
		});
	}
	searchClear(): void {
		let _self = this;
		$("#clear").on('click', function () {
			//alert("for checking");
			$('#search-input-header').val('');
			let redmCountry = $('#mh-country-dropdown').find(":selected").val();
			if (redmCountry != null && redmCountry != '' && redmCountry != undefined) {
				//alert("if.."+redmCountry);
			} else {
				redmCountry = _self.mhCountry;
			}
			if (window.location.hostname === 'localhost') {
				window.location.href = "http://localhost:4506/content/mas/my/en/enrich-portal/home/redemption/mhvoucher.html?wcmmode=disabled&mhCountry=" + redmCountry;
			} else {
				let url = window.location.href.split('/');
				window.location.href = "https://" + window.location.hostname + "/" + url[3] + "/" + url[4] + "/enrich-portal/home/redemption/mhvoucher.html?mhCountry=" + redmCountry;
			}
		})
	}

	checkBoxTriggerEnable(): any {
		$('#enrich--form--checkbox').change(function () {
			if ($(this).is(':checked')) {
				$('#voucher-redeem--confirm--button').removeAttr('disabled', true);
			} else {
				$('#voucher-redeem--confirm--button').attr('disabled', true);
			}
		});
	}
	getCountrySelectedList(): any {
		let _self = this;
		$('#mh-country-dropdown').on('change', function () {
			var dropdownslecetedvalue = $(this).find(":selected").val();
			//alert("dropdownslecetedvalue..."+dropdownslecetedvalue);
			for (let i = 0; i < _self.countryList.length; i++) {
				if (dropdownslecetedvalue == _self.countryList[i].countryCode) {
					$(".icon-" + _self.countryList[i].countryName + "-flag").removeClass("hide");
				} else {
					$(".icon-" + _self.countryList[i].countryName + "-flag").addClass("hide");
				}
			}
			if (window.location.hostname === 'localhost') {
				window.location.href = "http://localhost:4506/content/mas/my/en/enrich-portal/home/redemption/mhvoucher.html?wcmmode=disabled&mhCountry=" + dropdownslecetedvalue;
			} else {
				let url = window.location.href.split('/');
				window.location.href = "https://" + window.location.hostname + "/" + url[3] + "/" + url[4] + "/enrich-portal/home/redemption/mhvoucher.html?mhCountry=" + dropdownslecetedvalue;
			}
		});
	}
	bannerRedirect(): void {
		let _self = this;
		$(".banner_img").click(function ($instance: any) {
			$instance.preventDefault();
			let vouchMaxLimit: any;
			let clickId = $(this).attr('id');
			let redmCountry = $('#mh-country-dropdown').find(":selected").val();
			if (redmCountry != null && redmCountry != '' && redmCountry != undefined) {
				//alert("if.."+redmCountry);
			} else {
				redmCountry = _self.mhCountry;
			}
			//alert("clickId.."+clickId);
			//alert("redmCountry.."+redmCountry);
			if (window.location.hostname === 'localhost') {
				window.location.href = "http://localhost:4506/content/mas/my/en/enrich-portal/home/redemption/mhvoucher.html?wcmmode=disabled&mhCountry=" + redmCountry + "&id=" + clickId;
			} else {
				let url = window.location.href.split('/');
				window.location.href = "https://" + window.location.hostname + "/" + url[3] + "/" + url[4] + "/enrich-portal/home/redemption/mhvoucher.html?mhCountry=" + redmCountry + "&id=" + clickId;
			}
		})
	}
	// redirectToHome(): void {
	// 	let _self = this;
	// 	$("#redirect_home").click(function ($instance: any) {
	// 		$instance.preventDefault();
	// 		if (window.location.hostname === 'localhost') {
	// 			window.location.href = "http://localhost:4506/content/mas/my/en/enrich-portal/home/redemption/mhvoucher.html?wcmmode=disabled";
	// 		} else {
	// 			let url = window.location.href;
	// 			window.location.href = url;
	// 		}
	// 	})
	// }
	redirectToPrevPage(): void {
		let _self = this;
		$("#redirect_prev_page").click(function ($instance: any) {
			$instance.preventDefault();
			$("#member-enrich-voucherdetailcatalogue").removeClass("hideclass");
			$("#member-enrich-voucherdetailcatalogue").addClass("showclass");
			$("#redirect_home").removeClass("hideclass");
			$("#redirect_home").addClass("showclass");
			$("#member-enrich-confirmRedemption").removeClass("showclass");
			$("#member-enrich-confirmRedemption").addClass("hideclass");
			$("#redirect_prev_page").removeClass("showclass");
			$("#redirect_prev_page").addClass("hideclass");
		})
	}

	showSlides(n: any): void {
		let _self = this;
		let i;
		//alert("_self.slideIndex..."+_self.slideIndex);
		const slides = document.getElementsByClassName("mySlides") as HTMLCollectionOf<HTMLElement>;
		let dots = document.getElementsByClassName("dot");
		if (n > slides.length) {
			_self.slideIndex = 1;
			//alert("1st if");
		}
		if (n < 1) {
			_self.slideIndex = slides.length;
			//alert("2nd iff");
		}
		for (i = 0; i < slides.length; i++) {
			slides[i].style.display = "none";
		}
		for (i = 0; i < dots.length; i++) {
			dots[i].className = dots[i].className.replace(" active", "");
		}
		slides[_self.slideIndex - 1].style.display = "block";
		dots[_self.slideIndex - 1].className += " active";
	}
	plusSlides(): void {
		let _self = this;
		$(".arrowclick").click(function ($instance: any) {
			let n = $(this).attr('id');
			_self.showSlides(_self.slideIndex += parseInt(n));
		})
	}
	currentSlide(): void {
		let _self = this;
		$(".dot").click(function ($instance: any) {
			let n = $(this).attr('id');
			_self.showSlides(_self.slideIndex = parseInt(n));
		})
	}


};
/**
		 * common function to set incrementer value/display for click/hold events
		 * @param  {any}    elDisplay [description]
		 * @param  {any}    input     [description]
		 * @param  {any}    curVal    [description]
		 * @param  {any}    params    [description]
		 * @param  {string} type      [description]
		 * @return {any}              [description]
		 */
function setIncrementer(elDisplay: any, input: any, curVal: any, params: any, type: string,): any {
	if (type == 'decrement') {
		if (curVal > params.min) {
			curVal--;
		}
		if (!$("#limit_control_err_msg").hasClass("hideclass")) {
			$("#limit_control_err_msg").addClass("hideclass");
			$("#limit_control_err_msg").removeClass("showclass");
		}
	}

	if (type == 'increment') {
		if (curVal < params.max) {
			curVal++;
			$(".redeem-incrementer").removeClass("disablee");
			if ($(".redeem-decremeneter").hasClass("disablee")) {
				$(".redeem-decremeneter").removeClass("disablee");
			}
			if (!$("#limit_control_err_msg").hasClass("hideclass")) {
				$("#limit_control_err_msg").addClass("hideclass");
				$("#limit_control_err_msg").removeClass("showclass");
			}
		}
		else {
			if (!$("#limit_control_err_msg").hasClass("showclass")) {
				$("#limit_control_err_msg").addClass("showclass");
				$("#limit_control_err_msg").removeClass("hideclass");
			}
			$(".redeem-incrementer").addClass("disablee");
		}
	}
	if (curVal <= params.min) {

		$(".redeem-decremeneter").addClass("disablee");
		if ($(".redeem-incrementer").hasClass("disablee")) {
			$(".redeem-incrementer").removeClass("disablee");
		}

	}
	else {
		$(".redeem-decremeneter").removeClass("disablee");

	}

	elDisplay.html(curVal);
	input.val(curVal);

	input.parent().trigger('voucher-quantity-incre-decre.changed', [curVal]);
	return curVal;
}
function updateProgress(progress: any) {
	const progressBar = document.getElementById('range-slider');
	progressBar.style.width = `${progress}%`;
}
/*function showSlides(n:any) {
	let _self = this;
	let i;
	const slides = document.getElementsByClassName("mySlides");
		let dots = document.getElementsByClassName("dot");
  if (n > slides.length) {_self.slideIndex = 1}    
  if (n < 1) {_self.slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
	slides[i].className = slides[i].className.replace("hideclass", "");;  
  }
  for (i = 0; i < dots.length; i++) {
	dots[i].className = dots[i].className.replace(" active", "");
  }
  slides[_self.slideIndex-1].className += "showclass";  
  dots[_self.slideIndex-1].className += " active";
}
function plusSlides(n:any): void {
	let _self=this;
	showSlides(_self.slideIndex += n);
}
function currentSlide(n:any) {
	let _self=this;
	showSlides(_self.slideIndex = n);
  }*/

let scope: Element = document.querySelector('#member-enrich-newcatalogue');
declare const window: any;
if (scope) {
	try {
		let enrichcatelogue = new enrichCatelogue();
		enrichcatelogue.loadCountryBanrData();
		enrichcatelogue.appendCategories();
		// enrichcatelogue.voucherDetailView();
		enrichcatelogue.accordionHowToUse();
		enrichcatelogue.iconToggle();
		//enrichcatelogue.redeemRange();
		// enrichcatelogue.textLimit();
		//enrichcatelogue.initIncrementer();
		//enrichcatelogue.textReadMore();
		enrichcatelogue.checkBoxTriggerEnable();
		enrichcatelogue.initRedeemSubmit();
		enrichcatelogue.initConfirmRedeemSubmit();
		enrichcatelogue.searchCatelogue();
		enrichcatelogue.searchClear();
		//enrichcatelogue.showSlides();
		enrichcatelogue.plusSlides();
		enrichcatelogue.currentSlide();
		enrichcatelogue.bannerRedirect();
		// enrichcatelogue.redirectToHome();
		enrichcatelogue.redirectToPrevPage();
	} catch (e) { console.error(e); }
}